import React from 'react';
import { Button } from "../../components/ui/button";
import { Gift, TrendingUp, Rocket } from "lucide-react";

const ReferralCard = () => {
    return (
        <div className="p-8 md:p-12 bg-white/5 backdrop-blur-sm border border-white/5 hover:border-market-teal/20 shadow-[0_0_50px_rgba(0,0,0,0.3)]">
            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                    Open a DHAN Demat. Get <span className="text-market-teal">₹1749</span> Worth Bonuses!
                </h2>

                <p className="text-xl text-gray-400 mb-12">
                    Special offer for new DHAN clients registered under Four Fox Media as AP.
                </p>

                <div className="grid md:grid-cols-3 gap-8 mb-12">
                    <div className="flex items-start space-x-4 bg-white/5 p-6 rounded-lg backdrop-blur-sm">
                        <Gift className="w-6 h-6 text-market-teal flex-shrink-0" />
                        <p className="text-white/90">3 Months Free MarketPulse Subscription (₹1749 Value)</p>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/5 p-6 rounded-lg backdrop-blur-sm">
                        <TrendingUp className="w-6 h-6 text-market-teal flex-shrink-0" />
                        <p className="text-white/90">Free TradingView Premium Features</p>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/5 p-6 rounded-lg backdrop-blur-sm">
                        <Rocket className="w-6 h-6 text-market-teal flex-shrink-0" />
                        <p className="text-white/90">Seamless API & Tools for Intraday Traders</p>
                    </div>
                </div>

                <Button
                    className="w-full bg-market-teal hover:bg-market-teal/80 text-black font-medium text-lg py-6"
                    asChild
                >
                    <a href="https://invite.dhan.co/?join=UTVA03~OPT" target="_blank" rel="noopener noreferrer">
                        Open DHAN Account Now
                    </a>
                </Button>

                <p className="text-sm text-gray-500 mt-6 text-center">
                    Offer only valid if your DHAN account is registered under Four Fox Media as your Authorized Partner (AP).
                </p>
            </div>
        </div>
    );
};

export default ReferralCard;